import React, {useState} from 'react';
import Button from "react-bootstrap/lib/Button";
import {getPublish} from "../api";

function PublishTab(props) {
    const [alert, setAlert] = useState(null);

    function onPublishClick() {
        const callback = () => {
            setAlert(<div className="alert alert-success" role="alert">Success!</div>)
        };

        getPublish(props.user.api_token, callback)
    }

    return (
        <div>
            <p>Here you can publish Overview and Preview html files to Amazon S3, click on the next button:</p>

            <Button bsStyle="success" onClick={onPublishClick}>
                Publish
            </Button>
            <br/>
            <br/>
            {alert}
        </div>
    )
}

export default PublishTab
